<script>
import { Bar, mixins } from "vue-chartjs";

const { reactiveProp } = mixins;

export default {
  name: "DailyCasesByPriorityChart",
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Array,
      default: () => []
    },
    data1: {
      type: Array,
      default: () => []
    },
    data2: {
      type: Array,
      default: () => []
    },
    data3: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    timespan: {
      type: String,
      default: "month"
    }
  },
  computed: {
    lastXdays() {
      if (this.isAdmin) {
        if (this.timespan === "month") {
          return "Last 30 days";
        } else {
          return "Last 7 days";
        }
      } else {
        return "Last 5 days";
      }
    }
  },
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: "No Complaint",
            backgroundColor: "lightgreen",
            data: this.chartData
          },
          {
            label: "Routine",
            backgroundColor: "#62B96F",
            data: this.data3
          },
          {
            label: "Urgent",
            backgroundColor: "#EDCD55",
            data: this.data2
          },
          {
            label: "Critical",
            backgroundColor: "#D05052",
            data: this.data1
          }
        ]
      },
      {
        title: {
          display: true,
          fontSize: 19.2,
          text: `Daily Cases (${this.lastXdays})`
        },
        scales: {
          xAxes: [{ stacked: true }],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                userCallback: function(label) {
                  // when the floored value is the same as the value we have a whole number
                  if (Math.floor(label) === label) {
                    return label;
                  }
                }
              },
              stacked: true
            }
          ]
        },
        responsive: true,
        maintainAspectRatio: false
      }
    );
  }
};
</script>
